"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonConfirmNextSection = exports.buttonSaveTrip = exports.segmentHasNextMode = exports.segmentBusLinesWarning = exports.segmentBusLines = exports.tripJunctionGeography = exports.segmentDriver = exports.segmentHowToBus = exports.segmentMode = exports.segmentModePre = exports.segmentSameModeAsReverseTrip = exports.segments = exports.segmentIntro = exports.personTrips = exports.personVisitedPlacesMap = exports.segmentsPersonTripsTitle = exports.buttonSwitchPerson = exports.activePersonTitle = void 0;
const get_1 = __importDefault(require("lodash/get"));
const upperFirst_1 = __importDefault(require("lodash/upperFirst"));
const escape_1 = __importDefault(require("lodash/escape"));
const project_config_1 = __importDefault(require("evolution-common/lib/config/project.config"));
const odSurveyHelpers = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const validations = __importStar(require("evolution-common/lib/services/widgets/validations/validations"));
const widgetsSwitchPerson_1 = require("evolution-common/lib/services/questionnaire/sections/common/widgetsSwitchPerson");
const widgetPersonTripsTitle_1 = require("evolution-common/lib/services/questionnaire/sections/segments/widgetPersonTripsTitle");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const frontendHelper_1 = require("evolution-frontend/lib/services/display/frontendHelper");
const groupPersonTrips_1 = require("evolution-common/lib/services/questionnaire/sections/segments/groupPersonTrips");
const widgetTripSegmentsIntro_1 = require("evolution-common/lib/services/questionnaire/sections/segments/widgetTripSegmentsIntro");
const groupSegments_1 = require("evolution-common/lib/services/questionnaire/sections/segments/groupSegments");
const widgetSameAsReverseTrip_1 = require("evolution-common/lib/services/questionnaire/sections/segments/widgetSameAsReverseTrip");
const widgetSegmentModePre_1 = require("evolution-common/lib/services/questionnaire/sections/segments/widgetSegmentModePre");
const widgetSegmentMode_1 = require("evolution-common/lib/services/questionnaire/sections/segments/widgetSegmentMode");
const widgetSegmentHasNextMode_1 = require("evolution-common/lib/services/questionnaire/sections/segments/widgetSegmentHasNextMode");
const buttonSaveTripSegments_1 = require("evolution-common/lib/services/questionnaire/sections/segments/buttonSaveTripSegments");
const buttonValidateAndGotoNextSection_1 = require("evolution-common/lib/services/questionnaire/sections/common/buttonValidateAndGotoNextSection");
const helpers_2 = require("evolution-common/lib/services/questionnaire/sections/segments/helpers");
const helper_1 = require("../../common/helper");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const customWidgets_1 = require("../visitedPlaces/customWidgets");
const widgetsNames_1 = require("./widgetsNames");
const modeIconMapping_1 = require("evolution-common/lib/services/questionnaire/sections/segments/modeIconMapping");
const types_1 = require("evolution-common/lib/services/odSurvey/types");
const customValidations_1 = require("../../common/customValidations");
let busRoutes = { type: 'FeatureCollection', features: [] };
// Use async immediately invoked function (IIFE) to handle dynamic import instead of using a require, which causes linter error
(() => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // FIXME Can't use dynamic import as webpack does not find the file and complains the dependency is an expression
        /* eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports */
        busRoutes = require(`../../config/busRoutes${(0, upperFirst_1.default)(process.env.EV_VARIANT)}.json`);
        busRoutes.features = busRoutes.features.sort((a, b) => (a.properties.sortableName || '').localeCompare(b.properties.sortableName));
    }
    catch (error) {
        // No bus routes found for this ev variant, it's ok, the question just won't be asked
        console.log('No bus routes found for this survey');
    }
}))();
const switchPersonWidgets = (0, widgetsSwitchPerson_1.getSwitchPersonWidgets)();
exports.activePersonTitle = switchPersonWidgets.activePersonTitle;
exports.buttonSwitchPerson = switchPersonWidgets.buttonSwitchPerson;
exports.segmentsPersonTripsTitle = (0, widgetPersonTripsTitle_1.getPersonsTripsTitleWidgetConfig)({
    getFormattedDate: frontendHelper_1.getFormattedDate
});
// FIXME This is the exact same widget, same name as the one in visitedPlaces, we should not have to duplicate it, but that's how the generator currently works
exports.personVisitedPlacesMap = customWidgets_1.personVisitedPlacesMap;
exports.personTrips = Object.assign(Object.assign({}, (0, groupPersonTrips_1.getPersonsTripsGroupConfig)()), { widgets: widgetsNames_1.personTripsWidgetsNames });
exports.segmentIntro = (0, widgetTripSegmentsIntro_1.getTripSegmentsIntro)();
exports.segments = Object.assign(Object.assign({}, (0, groupSegments_1.getSegmentsGroupConfig)()), { widgets: widgetsNames_1.segmentsWidgetsNames });
exports.segmentSameModeAsReverseTrip = (0, widgetSameAsReverseTrip_1.getSameAsReverseTripWidgetConfig)();
exports.segmentModePre = Object.assign(Object.assign({}, (0, widgetSegmentModePre_1.getModePreWidgetConfig)()), { choices: [
        {
            value: 'carDriver',
            label: {
                fr: '<strong>Conducteur</strong> (voiture/moto/scooter)',
                en: '<strong>Driver</strong> (car/motorcycle/moped)'
            },
            conditional: function (interview, path) {
                const person = odSurveyHelpers.getActivePerson({ interview });
                const drivingLicenseOwnership = person ? person.drivingLicenseOwnership : 'dontKnow';
                return drivingLicenseOwnership === 'yes';
            },
            iconPath: (0, modeIconMapping_1.getModeIcon)('carDriver')
        },
        {
            value: 'carPassenger',
            label: {
                fr: '<strong>Passager</strong> (voiture/moto/scooter)',
                en: '<strong>Passenger (car/motorcycle/moped)</strong>'
            },
            iconPath: (0, modeIconMapping_1.getModeIcon)('carPassenger')
        },
        {
            value: 'walk',
            label: {
                fr: '<strong>Marche</strong>',
                en: '<strong>Walking</strong>'
            },
            iconPath: (0, modeIconMapping_1.getModeIcon)('walk')
        },
        {
            value: 'wheelchair',
            label: {
                fr: '<strong>Chaise roulante</strong>',
                en: '<strong>Wheelchair</strong>'
            },
            conditional: function (interview, path) {
                const person = odSurveyHelpers.getActivePerson({ interview });
                return person && odSurveyHelpers.personMayHaveDisability({ person });
            },
            iconPath: (0, modeIconMapping_1.getModeIcon)('wheelchair')
        },
        {
            value: 'mobilityScooter',
            label: {
                fr: '<strong>Quadriporteur/Triporteur</strong>',
                en: '<strong>Mobility scooter</strong>'
            },
            conditional: function (interview, path) {
                const person = odSurveyHelpers.getActivePerson({ interview });
                return person && odSurveyHelpers.personMayHaveDisability({ person });
            },
            iconPath: (0, modeIconMapping_1.getModeIcon)('mobilityScooter')
        },
        {
            value: 'paratransit',
            label: {
                fr: '<strong>Transport adapté</strong>',
                en: '<strong>Paratransit</strong>'
            },
            iconPath: (0, modeIconMapping_1.getModeIcon)('paratransit'),
            conditional: function (interview, path) {
                const person = odSurveyHelpers.getActivePerson({ interview });
                // paratransit can be used by an accompanying person too, so show this mode for any household with at least one person with disability:
                return ((person && odSurveyHelpers.personMayHaveDisability({ person })) ||
                    odSurveyHelpers.householdMayHaveDisability({ interview }));
            }
        },
        {
            value: 'bicycle',
            label: {
                fr: '<strong>Vélo</strong> ou <strong> vélo électrique</strong>',
                en: '<strong>Bicycle</strong> or <strong>electric bicycle</strong>'
            },
            iconPath: (0, modeIconMapping_1.getModeIcon)('bicycle')
        },
        {
            value: 'transit',
            label: {
                fr: '<strong>Transport collectif</strong>',
                en: '<strong>Public transit</strong>'
            },
            iconPath: (0, modeIconMapping_1.getModeIcon)('transitBus')
        },
        {
            value: 'taxi',
            label: {
                fr: '<strong>Taxi</strong> ou équivalent (ex. Uber)',
                en: '<strong>Taxi</strong> or equivalent (eg. Uber)'
            },
            iconPath: (0, modeIconMapping_1.getModeIcon)('taxi')
        },
        {
            value: 'ferry',
            label: {
                fr: '<strong>Traversier</strong>',
                en: '<strong>Ferry</strong>'
            },
            iconPath: (0, modeIconMapping_1.getModeIcon)('transitFerry')
        },
        {
            value: 'other',
            label: {
                fr: '<strong>Autre</strong>',
                en: '<strong>Other</strong>'
            },
            iconPath: (0, modeIconMapping_1.getModeIcon)('other')
        },
        {
            value: 'dontKnow',
            label: {
                fr: '<strong>Je ne sais pas</strong> / Préfère ne pas répondre',
                en: '<strong>I don\'t know</strong> / Prefer not to answer'
            },
            iconPath: (0, modeIconMapping_1.getModeIcon)('dontKnow')
        }
    ] });
const segmentModeChoices = [
    {
        value: 'bicycle',
        label: {
            fr: '<strong>Vélo</strong>',
            en: '<strong>Bicycle</strong>'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'bicycle';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('bicycle')
    },
    {
        value: 'bicycleElectric',
        label: {
            fr: '<strong>Vélo électrique</strong>',
            en: '<strong>E-Bike</strong> (electric bicycle)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            const person = odSurveyHelpers.getActivePerson({ interview });
            return modePre === 'bicycle' && person && !(0, LodashExtensions_1._isBlank)(person.age) && person.age >= 14;
        },
        // FIXME In Evolution, the bicycleElectric mode was meant to be an extra
        // question, with `bicycle` as mode and use the `BicycleType` to answer
        // the new question. In this survey, it is still a mode, so we manually
        // set the icon path for it.
        iconPath: '/dist/icons/modes/bicycle/bicycle_without_rider_electric.svg'
    },
    {
        value: 'kickScooterElectric',
        label: {
            fr: '<strong>Trottinette électrique</strong>',
            en: '<strong>E-Scooter</strong> (electric scooter)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            const person = odSurveyHelpers.getActivePerson({ interview });
            return ((modePre === 'bicycle' || modePre === 'other') && person && !(0, LodashExtensions_1._isBlank)(person.age) && person.age >= 14);
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('kickScooterElectric')
    },
    {
        value: 'mobilityScooter',
        label: {
            fr: '<strong>Quadriporteur/triporteur</strong>',
            en: '<strong>Mobility scooter</strong>'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'mobilityScooter' || modePre === 'other';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('mobilityScooter')
    },
    {
        value: 'wheelchair',
        label: {
            fr: '<strong>Chaise roulante</strong>',
            en: '<strong>Wheelchair</strong>'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'wheelchair';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('wheelchair')
    },
    {
        value: 'transitBus',
        label: {
            fr: '<strong>Bus</strong> (transport collectif)',
            en: '<strong>Bus</strong> (public transit)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'transit';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('transitBus')
    },
    {
        value: 'transitSubway',
        label: {
            fr: '<strong>Métro<strong>',
            en: '<strong>Metro<strong> (subway)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'transit';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('transitRRT')
    },
    {
        value: 'transitREM',
        label: {
            fr: '<strong>REM</strong>',
            en: '<strong>REM</strong>'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'transit';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('transitLRT')
    },
    {
        value: 'transitRail',
        label: {
            fr: '<strong>Train de banlieue</strong> (exo)',
            en: '<strong>Commuter train</strong> (exo)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'transit';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('transitRegionalRail')
    },
    {
        value: 'transitTram',
        label: {
            fr: '<strong>Tramway</strong>',
            en: '<strong>Tram</strong>'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'transit';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('transitStreetCar')
    },
    {
        value: 'transitTaxi',
        label: {
            fr: '<strong>Taxi collectif</strong> / Transport à la demande',
            en: '<strong>Taxibus</strong> / On-demand transport'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'other' || modePre === 'transit';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('transitTaxi')
    },
    {
        value: 'intercityBus',
        label: {
            fr: '<strong>Bus interurbain</strong> (Orléans, Kéolis, etc.)',
            en: '<strong>Intercity bus</strong> (Orleans, Keolis, etc.)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const tripDistanceMeters = (0, helper_1.getCurrentTripBirdDistanceMeters)({ interview });
            const modePre = segment ? segment.modePre : null;
            return (['transit', 'other'].includes(modePre) && ((0, LodashExtensions_1._isBlank)(tripDistanceMeters) || tripDistanceMeters >= 50000));
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('intercityBus')
    },
    {
        value: 'schoolBus',
        label: {
            fr: '<strong>Autobus scolaire</strong> (jaune)',
            en: '<strong>School bus</strong> (yellow)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            const person = odSurveyHelpers.getPerson({ interview });
            return (['transit', 'other'].includes(modePre) &&
                person &&
                ((person.age && person.age <= 15) || (0, helper_1.isStudent)(person)));
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('schoolBus')
    },
    {
        value: 'busOther',
        label: {
            fr: '<strong>Bus nolisé</strong> ou privé',
            en: '<strong>Chartered</strong> or private <strong>bus</strong>'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'transit' || modePre === 'other';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('otherBus')
    },
    {
        value: 'carDriver',
        label: {
            fr: '<strong>Voiture personnelle</strong> (appartenant à soi, un.e ami.e, la famille, etc.)',
            en: '<strong>Personal car</strong> (can belong to self, friend, family, etc)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'carDriver';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('carDriver')
    },
    {
        value: 'carDriverCarsharing',
        label: {
            fr: '<strong>Autopartage</strong> (ex. Communauto)',
            en: '<strong>Carsharing</strong> (ex. Communauto)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            const carsharingMembersCount = (0, helper_1.carsharingMembersCountInHousehold)(interview);
            return modePre === 'carDriver' && carsharingMembersCount > 0;
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('carDriver')
    },
    {
        value: 'rentalCar',
        label: {
            fr: '<strong>Voiture louée</strong> (Hertz, Enterprise, Budget, Avis, etc.)',
            en: '<strong>Rental car</strong> (Hertz, Enterprise, Budget, Avis, etc.)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'carDriver';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('carDriver')
    },
    {
        value: 'motorcycle',
        label: {
            fr: '<strong>Moto</strong> (ou scooter)',
            en: '<strong>Motorcycle</strong> (or motorized scooter/moped)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'carDriver' || modePre === 'other';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('motorcycle')
    },
    {
        value: 'ferryNoCar',
        label: {
            fr: '<strong>Traversier ou navette fluviale</strong> sans véhicule',
            en: '<strong>Ferry or river shuttle</strong> without vehicle'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'other' || modePre === 'transit' || modePre === 'ferry';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('transitFerry')
    },
    {
        value: 'ferryWithCar',
        label: {
            fr: '<strong>Traversier avec véhicule</strong>',
            en: '<strong>Ferry with vehicle</strong>'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'other' || modePre === 'transit' || modePre === 'ferry';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('ferryWithCar')
    },
    {
        value: 'intercityRail',
        label: {
            fr: '<strong>Train interurbain</strong> (VIA Rail)',
            en: '<strong>Intercity train</strong> (VIA Rail)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const tripDistanceMeters = (0, helper_1.getCurrentTripBirdDistanceMeters)({ interview });
            const modePre = segment ? segment.modePre : null;
            return (['transit', 'other'].includes(modePre) && ((0, LodashExtensions_1._isBlank)(tripDistanceMeters) || tripDistanceMeters >= 50000));
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('intercityTrain')
    },
    {
        value: 'carPassenger',
        label: {
            fr: '<strong>Passager</strong> (voiture/moto/scooter)',
            en: '<strong>Passenger</strong> (car/motorcycle/moped)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'carPassenger';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('carPassenger')
    },
    {
        value: 'paratransit',
        label: {
            fr: '<strong>Transport adapté</strong>',
            en: '<strong>Paratransit</strong>'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            const person = odSurveyHelpers.getActivePerson({ interview });
            // paratransit can be used by an accompanying person too, so show this mode for any household with at least one person with disability:
            return (['transit', 'other', 'carPassenger', 'paratransit'].includes(modePre) &&
                person &&
                (odSurveyHelpers.personMayHaveDisability({ person }) ||
                    odSurveyHelpers.householdMayHaveDisability({ interview })));
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('paratransit')
    },
    {
        value: 'plane',
        label: {
            fr: '<strong>Avion</strong>',
            en: '<strong>Airplane</strong>'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const tripDistanceMeters = (0, helper_1.getCurrentTripBirdDistanceMeters)({ interview });
            const modePre = segment ? segment.modePre : null;
            return modePre === 'other' && ((0, LodashExtensions_1._isBlank)(tripDistanceMeters) || tripDistanceMeters >= 50000);
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('plane')
    },
    {
        value: 'other',
        label: {
            fr: '<strong>Autre</strong>',
            en: '<strong>Other</strong>'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'other';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('other')
    },
    {
        value: 'walk',
        label: {
            fr: '<strong>Marche</strong>',
            en: '<strong>Walking</strong>'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'walk';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('walk')
    },
    {
        value: 'taxi',
        label: {
            fr: '<strong>Taxi</strong> ou équivalent (ex. Uber)',
            en: '<strong>Taxi</strong> or equivalent (eg. Uber)'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'taxi';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('taxi')
    },
    {
        value: 'dontKnow',
        label: {
            fr: '<strong>Je ne sais pas</strong> / Préfère ne pas répondre',
            en: '<strong>I don\'t know</strong> / Prefer not to answer'
        },
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const modePre = segment ? segment.modePre : null;
            return modePre === 'dontKnow';
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('dontKnow')
    }
];
// FIXME Because of different choices, we need to overwrite the conditional as
// well, but if we could parameterize the choices, the main conditional would be
// ok
exports.segmentMode = Object.assign(Object.assign({}, (0, widgetSegmentMode_1.getModeWidgetConfig)()), { choices: segmentModeChoices, conditional: (interview, path) => {
        const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
        const shouldShowSameAsReverseTrip = (0, helpers_2.shouldShowSameAsReverseTripQuestion)({ interview, segment });
        // Do not show if the question of the same mode as previous trip is shown and the answer is not 'no'
        if (shouldShowSameAsReverseTrip && segment.sameModeAsReverseTrip !== false) {
            if (segment.sameModeAsReverseTrip === true) {
                // If the question of the same mode as previous trip is shown and the answer is yes, the mode is the same as the previous trip
                const previousTripSegment = (0, helpers_2.getPreviousTripSingleSegment)({
                    interview,
                    person: odSurveyHelpers.getActivePerson({ interview })
                });
                if (previousTripSegment && previousTripSegment.mode !== undefined) {
                    return [false, previousTripSegment.mode];
                }
            }
            // Otherwise, initialize to null
            return [false, null];
        }
        // Make sure modePre is selected before displaying
        const modePre = segment ? segment.modePre : null;
        if ((0, LodashExtensions_1._isBlank)(modePre)) {
            return [false, null];
        }
        // Check if there is more than one choice available for this trip
        const modes = segmentModeChoices.filter((choice) => choice.conditional(interview, path) === true);
        if (modes.length === 1 || modes.length === 0) {
            if (modes.length === 0) {
                console.warn(`No mode available for modePre '${modePre}' in segmentModeChoices. That may break icon display and eventual choice validation.`);
            }
            return [false, modes[0] ? modes[0].value : modePre];
        }
        return [true, null];
    } });
const howToBusChoices = [
    {
        value: 'walk',
        label: {
            fr: '<strong>Marche</strong>',
            en: '<strong>Walking</strong>'
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('walk')
    },
    {
        value: 'bicycle',
        label: {
            fr: '<strong>Vélo</strong>',
            en: '<strong>Bicycle</strong>'
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('bicycle')
    },
    {
        value: 'bicycleElectric',
        label: {
            fr: '<strong>Vélo électrique</strong>',
            en: '<strong>E-Bike</strong> (electric bicycle)'
        },
        // FIXME bicycleElectric is not a mode (see comment in segmentModeChoices), use a function when bicycle type is available in Evolution
        iconPath: '/dist/icons/modes/bicycle/bicycle_without_rider_electric.svg'
    },
    {
        value: 'kickScooterElectric',
        label: {
            fr: '<strong>Trottinette électrique</strong>',
            en: '<strong>E-Scooter</strong> (electric scooter)'
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('kickScooterElectric')
    },
    {
        value: 'wheelchair',
        label: {
            fr: '<strong>Chaise roulante</strong>',
            en: '<strong>Wheelchair</strong>'
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('wheelchair'),
        conditional: function (interview, path) {
            const person = odSurveyHelpers.getActivePerson({ interview });
            return person && odSurveyHelpers.personMayHaveDisability({ person });
        }
    },
    {
        value: 'mobilityScooter',
        label: {
            fr: '<strong>Quadriporteur/Triporteur</strong>',
            en: '<strong>Mobility scooter</strong>'
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('mobilityScooter'),
        conditional: function (interview, path) {
            const person = odSurveyHelpers.getActivePerson({ interview });
            return person && odSurveyHelpers.personMayHaveDisability({ person });
        }
    },
    {
        value: 'paratransit',
        label: {
            fr: '<strong>Transport adapté</strong>',
            en: '<strong>Paratransit</strong>'
        },
        iconPath: (0, modeIconMapping_1.getModeIcon)('paratransit'),
        conditional: function (interview, path) {
            const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
            const mode = segment ? segment.mode : null;
            const person = odSurveyHelpers.getActivePerson({ interview });
            // paratransit can be used by an accompanying person too, so show this mode for any household with at least one person with disability:
            return ((mode !== 'paratransit' && person && odSurveyHelpers.personMayHaveDisability({ person })) ||
                odSurveyHelpers.householdMayHaveDisability({ interview }));
        }
    }
];
exports.segmentHowToBus = {
    type: 'question',
    path: 'howToBus',
    inputType: 'radio',
    containsHtml: true,
    twoColumns: false,
    datatype: 'string',
    iconSize: '1.5em',
    columns: 1,
    choices: howToBusChoices,
    label: (t, interview, path) => {
        const person = odSurveyHelpers.getActivePerson({ interview });
        return t('segments:howToBus', {
            context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
            nickname: (0, escape_1.default)(person.nickname),
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
        });
    },
    conditional: function (interview, path) {
        const segment = (0, helpers_1.getResponse)(interview, path, null, '../');
        const modePre = segment ? segment.modePre : null;
        const mode = segment ? segment.mode : null;
        const trip = odSurveyHelpers.getActiveTrip({ interview });
        const segmentsArray = odSurveyHelpers.getSegmentsArray({ trip });
        const isFirst = segmentsArray[0] === segment;
        return [modePre === 'transit' && isFirst && mode !== 'paratransit', modePre];
    },
    validations: function (value, customValue, interview, path, customPath) {
        return [
            {
                validation: (0, LodashExtensions_1._isBlank)(value),
                errorMessage: {
                    fr: 'Le mode de transport est requis.',
                    en: 'Mode of transport is required.'
                }
            }
        ];
    }
};
exports.segmentDriver = {
    type: 'question',
    path: 'driver',
    inputType: 'select',
    datatype: 'string',
    twoColumns: false,
    label: (t, interview, path) => {
        const person = odSurveyHelpers.getActivePerson({ interview });
        return t('segments:driver', {
            context: (person === null || person === void 0 ? void 0 : person.gender) || (person === null || person === void 0 ? void 0 : person.sexAssignedAtBirth),
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
        });
    },
    choices: function (interview) {
        const person = odSurveyHelpers.getActivePerson({ interview });
        const choices = [
            {
                groupShortname: '',
                groupLabel: '',
                choices: [
                    {
                        value: 'familyMember',
                        label: (t) => t('segments:driverFamily')
                    },
                    {
                        value: 'colleague',
                        label: (t) => t('segments:driverColleague')
                    }
                ]
            },
            {
                groupShortname: '',
                groupLabel: '',
                choices: [
                    {
                        value: 'taxiDriver',
                        label: (t) => t('segments:driverTaxi')
                    },
                    {
                        value: 'transitTaxiDriver',
                        label: (t) => t('segments:driverTransitTaxi')
                    },
                    {
                        value: 'paratransit',
                        label: (t) => t('segments:driverParaTransit'),
                        conditional: function (interview, path) {
                            // paratransit can be used by an accompanying person too, so show this mode for any household with at least one person with disability:
                            return (odSurveyHelpers.personMayHaveDisability({ person }) ||
                                odSurveyHelpers.householdMayHaveDisability({ interview }));
                        }
                    },
                    {
                        value: 'covoiturage',
                        label: (t) => t('segments:driverCarpool')
                    },
                    {
                        value: 'other',
                        label: (t) => t('segments:driverOther')
                    },
                    {
                        value: 'dontKnow',
                        label: (t) => t('segments:driverDontKnow'),
                        conditional: function (interview, path) {
                            return !odSurveyHelpers.getCountOrSelfDeclared({ interview, person });
                        }
                    }
                ]
            }
        ];
        // Ajout des personnes avec permis dans le ménage
        const drivers = (0, helper_1.getDrivers)({ interview });
        const hhDrivers = [];
        for (let i = 0, count = drivers.length; i < count; i++) {
            const driver = drivers[i];
            if (driver._uuid !== person._uuid) {
                hhDrivers.push({
                    value: driver._uuid,
                    label: !(0, LodashExtensions_1._isBlank)(driver.nickname)
                        ? driver.nickname
                        : (t) => t('segments:driverFamilyMemberSeq', { sequence: driver['_sequence'] })
                });
            }
        }
        if (hhDrivers.length > 0) {
            choices.unshift({
                groupShortname: '',
                groupLabel: '',
                choices: hhDrivers
            });
        }
        return choices;
    },
    conditional: function (interview, path) {
        const mode = (0, helpers_1.getResponse)(interview, path, null, '../mode');
        if (mode !== 'carPassenger') {
            return [false, null];
        }
        const trip = odSurveyHelpers.getActiveTrip({ interview });
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const visitedPlaces = odSurveyHelpers.getVisitedPlaces({ journey });
        const destination = odSurveyHelpers.getDestination({ visitedPlaces, trip });
        const activity = destination ? destination.activity : null;
        return [activity !== 'workOnTheRoad', null];
    },
    validations: validations.requiredValidation
};
exports.tripJunctionGeography = {
    type: 'question',
    inputType: 'mapFindPlace',
    path: 'junctionGeography',
    datatype: 'geojson',
    containsHtml: true,
    height: '32rem',
    refreshGeocodingLabel: {
        fr: 'Chercher le lieu de jonction à partir du nom ou de l\'adresse',
        en: 'Search the junction location using the place name or address'
    },
    autoConfirmIfSingleResult: true,
    label: (t) => t('segments:junctionGeography'),
    icon: {
        url: (interview, path) => '/dist/icons/interface/markers/marker_round_with_small_circle_selected.svg',
        size: [35, 35]
    },
    placesIcon: {
        url: (interview, path) => '/dist/icons/interface/markers/marker_round_with_small_circle.svg',
        size: [35, 35]
    },
    selectedIcon: {
        url: (interview, path) => '/dist/icons/interface/markers/marker_round_with_small_circle_selected.svg',
        size: [35, 35]
    },
    defaultCenter: function (interview, path) {
        const person = odSurveyHelpers.getActivePerson({ interview });
        const trip = odSurveyHelpers.getActiveTrip({ interview });
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const visitedPlaces = odSurveyHelpers.getVisitedPlaces({ journey });
        const originVisitedPlace = odSurveyHelpers.getOrigin({ trip, visitedPlaces });
        if (originVisitedPlace) {
            const originGeography = odSurveyHelpers.getVisitedPlaceGeography({
                visitedPlace: originVisitedPlace,
                person,
                interview
            });
            const originCoordinates = (0, get_1.default)(originGeography, 'geometry.coordinates', null);
            if (originCoordinates) {
                return {
                    lat: originCoordinates[1],
                    lon: originCoordinates[0]
                };
            }
        }
        return project_config_1.default.mapDefaultCenter;
    },
    geocodingQueryString: function (interview, path) {
        return (0, helpers_1.formatGeocodingQueryStringFromMultipleFields)([
            (0, helpers_1.getResponse)(interview, path, null, '../tripJunctionQueryString')
        ]);
    },
    defaultValue: function (interview, path) {
        return undefined;
    },
    updateDefaultValueWhenResponded: true,
    conditional: function (interview, path) {
        const trip = odSurveyHelpers.getActiveTrip({ interview });
        if (trip) {
            const journey = odSurveyHelpers.getActiveJourney({ interview });
            const visitedPlaces = odSurveyHelpers.getVisitedPlaces({ journey });
            const destination = odSurveyHelpers.getDestination({ trip, visitedPlaces });
            const activity = destination ? destination.activity : null;
            const segments = odSurveyHelpers.getSegmentsArray({ trip });
            const currentSegment = (0, helpers_1.getResponse)(interview, path, undefined, '../');
            const segmentIndex = segments.findIndex((segment) => segment._sequence === (currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment._sequence));
            if (segmentIndex === undefined || segmentIndex === 0) {
                return [false, null];
            }
            const previousSegment = segments[segmentIndex - 1];
            return [(0, helper_1.shouldDisplayTripJunction)(previousSegment, currentSegment, activity), null];
        }
        return [false, null];
    },
    validations: function (value, customValue, interview, path, customPath) {
        const person = odSurveyHelpers.getActivePerson({ interview });
        if (odSurveyHelpers.isSelfDeclared({ person, interview })) {
            return [
                {
                    validation: (0, LodashExtensions_1._isBlank)(value),
                    errorMessage: {
                        fr: 'Cette réponse est requise.',
                        en: 'This field is required.'
                    }
                },
                ...(0, customValidations_1.inaccessibleZoneGeographyCustomValidation)(value, undefined, interview, path)
            ];
        }
        else {
            // accept blank if proxy:
            return [];
        }
    }
};
exports.segmentBusLines = {
    type: 'question',
    path: 'busLines',
    inputType: 'multiselect',
    multiple: true,
    datatype: 'string',
    twoColumns: false,
    containsHtml: true,
    shortcuts: [
        {
            value: 'other',
            label: (t) => t('segments:busLinesOther'),
            color: 'grey'
        },
        {
            value: 'dontKnow',
            label: (t) => t('segments:busLinesDontKnow'),
            color: 'grey'
        }
    ],
    choices: function (interview, path) {
        // Put possibles lines at the top of the choices
        const lineSummary = (0, helpers_1.getResponse)(interview, path, undefined, '../trRoutingResult');
        const lines = (lineSummary === null || lineSummary === void 0 ? void 0 : lineSummary.lines) || [];
        const busRoutesFeatures = busRoutes.features;
        const choices = busRoutesFeatures.map((busRoute) => {
            const busRouteName = busRoute.properties.name;
            const altLine = lines.find((line) => busRoute.properties.agencyId === line.agencyAcronym &&
                busRoute.properties.shortname === line.lineShortname);
            return {
                value: busRoute.properties.slug,
                color: busRoute.properties.color,
                label: {
                    fr: busRouteName,
                    en: busRouteName
                },
                altCount: altLine === undefined ? 0 : altLine.alternativeCount
            };
        });
        choices.sort((lineA, lineB) => {
            // Bigger value is better
            return lineB.altCount - lineA.altCount;
        });
        choices.push({
            value: 'other',
            color: '#666666',
            sortableName: 'zother',
            label: (t) => t('segments:busLinesOther')
        });
        choices.push({
            value: 'dontKnow',
            color: '#666666',
            sortableName: 'zdontknow',
            label: (t) => t('segments:busLinesDontKnow')
        });
        return choices;
    },
    label: (t, interview, path) => {
        const person = odSurveyHelpers.getPerson({ interview });
        const nickname = (0, escape_1.default)(person.nickname);
        return t('segments:busLines', {
            nickname,
            count: odSurveyHelpers.getCountOrSelfDeclared({ interview, person })
        });
    },
    conditional: function (interview, path) {
        const mode = (0, helpers_1.getResponse)(interview, path, null, '../mode');
        if (mode !== 'transitBus' || busRoutes.features.length === 0) {
            return [false, null];
        }
        const journey = odSurveyHelpers.getActiveJourney({ interview });
        const trip = odSurveyHelpers.getActiveTrip({ interview });
        const visitedPlaces = odSurveyHelpers.getVisitedPlaces({ journey });
        const destination = odSurveyHelpers.getDestination({ trip, visitedPlaces });
        const activity = destination ? destination.activity : null;
        return [!types_1.loopActivities.includes(activity), null];
    },
    validations: function (value, customValue, interview, path, customPath) {
        const person = odSurveyHelpers.getPerson({ interview });
        if (odSurveyHelpers.isSelfDeclared({ person, interview })) {
            return validations.requiredValidation(value, customValue, interview, path, customPath);
        }
        else {
            // accept blank if proxy:
            return [];
        }
    }
};
exports.segmentBusLinesWarning = {
    type: 'question',
    path: 'busLinesWarning',
    inputType: 'button',
    twoColumns: false,
    containsHtml: true,
    choices: function (interview, path) {
        return [
            {
                value: 'ok',
                color: 'grey',
                size: 'medium',
                label: (t) => t('segments:busLinesAreCorrect')
            }
        ];
    },
    label: (t) => t('segments:busLinesWarning'),
    conditional: function (interview, path) {
        const segmentMode = (0, helpers_1.getResponse)(interview, path, undefined, '../mode');
        const segmentBuses = (0, helpers_1.getResponse)(interview, path, undefined, `../${exports.segmentBusLines.path}`);
        if (segmentMode !== 'transitBus' || (0, LodashExtensions_1._isBlank)(segmentBuses)) {
            return [false, null];
        }
        const lineSummary = (0, helpers_1.getResponse)(interview, path, undefined, '../trRoutingResult');
        let hasImpossibleLine = false;
        if (lineSummary !== undefined) {
            const lines = lineSummary.lines || [];
            const busRoutesFeatures = busRoutes.features;
            const declaredBusRoutes = busRoutesFeatures.filter((busRoute) => segmentBuses.includes(busRoute.properties.slug));
            const impossibleBusRoutes = declaredBusRoutes.filter((busRoute) => lines.find((line) => busRoute.properties.agencyId === line.agencyAcronym &&
                busRoute.properties.shortname === line.lineShortname) === undefined);
            hasImpossibleLine = impossibleBusRoutes.length !== 0;
        }
        return [hasImpossibleLine, null];
    },
    validations: function (value, customValue, interview, path, customPath) {
        return [
            {
                validation: (0, LodashExtensions_1._isBlank)(value),
                errorMessage: (t) => t('segments:busLinesWarningRequired')
            }
        ];
    }
};
exports.segmentHasNextMode = (0, widgetSegmentHasNextMode_1.getSegmentHasNextModeWidgetConfig)();
exports.buttonSaveTrip = (0, buttonSaveTripSegments_1.getButtonSaveTripSegmentsConfig)({
    iconMapper: { 'check-circle': free_solid_svg_icons_1.faCheckCircle },
    buttonActions: { validateButtonAction: frontendHelper_1.validateButtonAction }
});
exports.buttonConfirmNextSection = (0, buttonValidateAndGotoNextSection_1.getButtonValidateAndGotoNextSection)('survey:ConfirmAndContinue', {
    iconMapper: { 'check-circle': free_solid_svg_icons_1.faCheckCircle },
    buttonActions: {
        validateButtonAction: frontendHelper_1.validateButtonActionWithCompleteSection
    }
});
